import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const lastnameEmpty = (control: FormControl) => {
    if (!control.value || control.value.length === 0) {
        return { lastnameEmpty: messages.validation.lastNameEmpty };
    }
};
